import{useApplicationState}from"../../state";export const readScheduleStoreLegacy=()=>useApplicationState.getState().schedule.store;